<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card">
      <Flow />
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex";
import Flow from "../../../components/flowchart/views/App.vue";
import processApi from "@/api/processesApi";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Workflow",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Flow,
  },
  data() {
    return {
      title: this.$t('pages.workflow.page.title')
    };
  },
  methods: {
    ...mapActions(["getUser"]),
  },
  created() {
    if (this.$can("list", "processes")) {
      processApi.show(this.$route.params.id).then((response) => {
        this.title = this.$t('pages.workflow.page.title') +" - " + response.data.name;
      });
    }
  },
};
</script>


